import { render, staticRenderFns } from "./voteDetail.vue?vue&type=template&id=217e869b&scoped=true"
import script from "./voteDetail.vue?vue&type=script&lang=js"
export * from "./voteDetail.vue?vue&type=script&lang=js"
import style0 from "./voteDetail.vue?vue&type=style&index=0&id=217e869b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e869b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217e869b')) {
      api.createRecord('217e869b', component.options)
    } else {
      api.reload('217e869b', component.options)
    }
    module.hot.accept("./voteDetail.vue?vue&type=template&id=217e869b&scoped=true", function () {
      api.rerender('217e869b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/pool/voteDetail.vue"
export default component.exports